import asperaSdk from '@ibm-aspera/sdk';
import { singletonFactory } from '@warehouse/shared/util';
import { WarehouseAsperaSdk } from '../core/aspera.sdk';

export const asperaSdkSingleton = singletonFactory<WarehouseAsperaSdk>({
	factory: () => asperaSdk,
});
